// @flow
import {
	ProductListSlider,
	EshopPhotogallery,
	EshopModel3D,
	EshopImageMagnify,
	EshopGalleryPopup,
	EshopOrderForm,
} from 'fg-frontend';

//ESHOP: fulltextovy naseptavac, povolte, pokud je aktivni fulltext feature
import EshopFulltextAutocomplete from 'fg-frontend/src/components/EshopFulltextAutocomplete';

import BtnVariant from './components/BtnVariant';

// ESHOP: Handler komponenta pro pridani/odebrani produktu z oblibenych/porovnavani (odeberte, pokud na projektu nepouzivate ani oblibene ani porovnavani)
import EshopUserToolsHandler from './components/EshopUserToolsHandler';


export default (props) => {
	switch (props.decorator || props.is) {
		case 'ProductListSlider':
			return ProductListSlider;
		case 'EshopPhotogallery':
			return EshopPhotogallery;
		case 'EshopModel3D':
			return EshopModel3D;
		case 'EshopImageMagnify':
			return EshopImageMagnify;
		case 'EshopGalleryPopup':
			return EshopGalleryPopup;
		case 'EshopOrderForm':
			return EshopOrderForm;
		case 'BtnVariant':
			return BtnVariant;
		case 'EshopFulltextAutocomplete':
			return EshopFulltextAutocomplete;
		case 'EshopUserToolsHandler':
			return EshopUserToolsHandler;
	}
};



// WEBPACK FOOTER //
// ./config/module-publish/resources-3dliving/js/configureEshopComponents.js